// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutBlockSeo_container__xW2uD","separator":"LayoutBlockSeo_separator__2pfL7","description":"LayoutBlockSeo_description__2ANwI"};